(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('AdviceQueryType', AdviceQueryType);

    AdviceQueryType.$inject = ['$resource'];

    function AdviceQueryType ($resource) {
        var resourceUrl =  'api/advice-query-types';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
